/*
 * <same-tone-slider> — extiende <card-product-slider>.
 * Hace fetch a la URL de la colección filtrada por el tono, REMUEVE la tarjeta del
 * producto actual (data-exclude-handle) y luego inyecta e inicializa el carrusel.
 * Si tras excluir no queda ningún producto, oculta la sección.
 */
(() => {
  const Base = customElements.get('card-product-slider');
  if (!Base || customElements.get('same-tone-slider')) return;

  class SameToneSlider extends Base {
    fetchItems() {
      if (!this.parent) return;
      const url = this.getAttribute('data-url');
      const excludeHandle = this.getAttribute('data-exclude-handle');

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const wrapper = doc.querySelector('.swiper-wrapper');
          if (!wrapper) return;

          // Excluir el producto actual del listado del mismo tono
          if (excludeHandle) {
            wrapper.querySelectorAll('.swiper-slide').forEach(slide => {
              const link = slide.querySelector('a[href*="/products/"]');
              if (!link) return;
              const path = (link.getAttribute('href') || '').split('?')[0];
              const handle = path.split('/products/')[1]?.split('/')[0];
              if (handle === excludeHandle) slide.remove();
            });
          }

          // Si tras excluir el producto actual no queda ninguna slide, la sección
          // se queda oculta (ej. el producto es el único de su tono).
          if (wrapper.querySelectorAll('.swiper-slide').length > 0) {
            this.querySelector('.swiper-wrapper').innerHTML = wrapper.innerHTML;
            // El <same-tone-slider> tiene su propio data-section-id, así que this.parent
            // se resuelve a sí mismo; quitamos 'hidden' de la <section> exterior real.
            const outer = this.closest('.section--same-tone') || this.parent;
            if (outer) outer.classList.remove('hidden');
            this.initSlider();
          }
        })
        .catch(e => console.error(e));
    }
  }

  customElements.define('same-tone-slider', SameToneSlider);
})();

document.addEventListener('shopify:section:load', event => {
  const el = event.target.querySelector('same-tone-slider');
  if (el) el.connectedCallback();
});
